import { defineStore } from 'pinia'

import { useStorage } from '@vueuse/core'

export default defineStore('favorites', () => {
  const favorites = useStorage('favorites', [] as Array<string>)
  return { favorites }
})
